import React, { useState } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  TableAction,
  TableWrapper,
  ModalDeleteConfirm,
  TableCellDefault,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatables, useFetch } from "App/hooks";
import { ModalForm, headCells, deleteLayananById } from "./helpers";
import { TYPE_INSTANCE1 } from "App/constants";
import { fetchData } from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export default function Layanan() {
  const classes = STYLE_DEFAULT_MASTER();

  const [showModal, setShowModal] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    spesific_code: "",
    initial: "",
    status: true,
    remark: "",
  });

  const [rows, setRows] = useFetch(
    TYPE_INSTANCE1,
    LIST_URL_MASTER.layanan.list
  );

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name", "spesific_code"],
  });

  function clickAdd() {
    setFormData({
      id: "",
      name: "",
      spesific_code: "",
      initial: "",
      status: true,
      remark: "",
    });
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      spesific_code: row?.spesific_code,
      name: row?.name,
      initial: row?.initial,
      status: row?.status,
      remark: row?.remark,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function setNewData() {
    const newData = await fetchData(
      TYPE_INSTANCE1,
      LIST_URL_MASTER.layanan.list
    );
    setRows(newData);
  }

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          data={formData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteLayananById(
              formData.id,
              setNewData,
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title='Daftar Kelas Kunjungan'
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>

                <TableCell align='left'>{row?.name}</TableCell>
                <TableCell align='left'>{row?.initial}</TableCell>
                <TableCell align='left'>{row?.spesific_code}</TableCell>
                <TableCell align='left'>
                  {row?.status ? "Aktif" : "Tidak Aktif"}
                </TableCell>
                <TableCell align='left'>{row?.remark}</TableCell>

                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
